var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcZiemia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000006684932602314391790000005356484153123782079_);fill:#00A4DF;}\n\t.st1{clip-path:url(#SVGID_00000006684932602314391790000005356484153123782079_);fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000006684932602314391790000005356484153123782079_);fill:#006633;}\n\t.st3{clip-path:url(#SVGID_00000006684932602314391790000005356484153123782079_);fill:#95C11F;}\n\t.st4{clip-path:url(#SVGID_00000006684932602314391790000005356484153123782079_);fill:#FFEE00;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "znak"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 50,
    cy: 50,
    r: 50
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119811007245853816590000002340745226402343337_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000119811007245853816590000002340745226402343337_)",
      fill: "#00A4DF"
    },
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119811007245853816590000002340745226402343337_)",
      fill: "#FFFFFF"
    },
    d: "M19,44 c44.74,0,81,36.26,81,81s-36.26,81-81,81s-81-36.26-81-81S-25.74,44,19,44 M19,39c-47.42,0-86,38.58-86,86s38.58,86,86,86 s86-38.58,86-86S66.42,39,19,39L19,39z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000119811007245853816590000002340745226402343337_)",
      fill: "#006633"
    },
    cx: 19,
    cy: 125,
    r: 81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119811007245853816590000002340745226402343337_)",
      fill: "#FFFFFF"
    },
    d: "M86,55 c44.74,0,81,36.26,81,81s-36.26,81-81,81S5,180.74,5,136S41.26,55,86,55 M86,50C38.58,50,0,88.58,0,136s38.58,86,86,86 s86-38.58,86-86S133.42,50,86,50L86,50z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000119811007245853816590000002340745226402343337_)",
      fill: "#95C11F"
    },
    cx: 86,
    cy: 136,
    r: 81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119811007245853816590000002340745226402343337_)",
      fill: "#FFFFFF"
    },
    d: "M24-44 c17.12,0,31,13.88,31,31S41.12,18,24,18S-7,4.12-7-13S6.88-44,24-44 M24-49C4.15-49-12-32.85-12-13S4.15,23,24,23S60,6.85,60-13 S43.85-49,24-49L24-49z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000119811007245853816590000002340745226402343337_)",
      fill: "#FFEE00"
    },
    cx: 24,
    cy: -13,
    r: 31
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZiemia);
export default __webpack_public_path__ + "static/media/icZiemia.1957005dc8dc7ce619f41d47e0f64b28.svg";
export { ForwardRef as ReactComponent };